import { render, staticRenderFns } from "./banner-manage.vue?vue&type=template&id=ffb850a6&"
import script from "./banner-manage.vue?vue&type=script&lang=js&"
export * from "./banner-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports